import { Pressable, StyleSheet, View } from "react-native";
import CustomButton from "../../common/general/CustomButton/CustomButton";
import { MotiView } from "moti";
import CustomText from "../../common/general/CustomText/CustomText";
import { File } from "../../svgs/CustomCoursework";
import { Trash } from "@phosphor-icons/react/dist/csr/Trash";
import useFileFetch from "../../../hooks/useFileFetch";
import { File as FileType } from "../../../graphql/generated/graphql";

interface ResourceCardProps {
  file: Partial<FileType>;
  showDate?: boolean;
  showDelete?: boolean;
  onDelete?: () => void;
}

const ResourceCard = ({ file, showDate = false, showDelete = false, onDelete = null }: ResourceCardProps) => {
  const { fetchAndOpenFile } = useFileFetch();

  const formattedDate = file.created && showDate ? new Date(file.created).toLocaleDateString() : null;

  return (
    <MotiView
      from={{
        opacity: 0,
        translateX: -400,
      }}
      animate={{
        opacity: 1,
        translateX: 0,
      }}
      delay={200}
      // @ts-expect-error - transition is not typed
      transition={{
        type: "spring",
        damping: 18,
        stiffness: 120,
      }}>
      <Pressable
        onPress={() => fetchAndOpenFile(file.fileURL)}
        role="button"
        accessibilityLabel={`Open resource ${file.fileName}`}
        aria-label={`Open resource ${file.fileName}`}>
        <View style={styles.resourceCard}>
          <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <View style={{ flexDirection: "column" }}>
              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <File width={16} height={16} style={{ paddingRight: 4 }} alt={`File icon for ${file.fileName}`} />
                <CustomText
                  useTranslationText={false}
                  numberOfLines={1}
                  text={file.fileName}
                  style={{ maxWidth: 200 }}
                  weight="normal"
                  size="s"
                />
              </View>
              {formattedDate && (
                <CustomText
                  useTranslationText={false}
                  text={`Added: ${formattedDate}`}
                  style={{ color: "#667085", marginTop: 4 }}
                  size="xs"
                />
              )}
            </View>
            {showDelete && onDelete && (
              <CustomButton
                styleType="transparent"
                onPress={onDelete}
                leftIcon={<Trash size={16} alt={`Delete icon for ${file.fileName}`} />}
                accessibilityLabel={`Delete resource ${file.fileName}`}
                aria-label={`Delete resource ${file.fileName}`}
              />
            )}
          </View>
        </View>
      </Pressable>
    </MotiView>
  );
};

export default ResourceCard;

const styles = StyleSheet.create({
  resourceCard: {
    width: 290,
    flexDirection: "column",
    padding: 10,
    backgroundColor: "#fff",
    borderColor: "#D9D9D9",
    borderWidth: 1,
    borderRadius: 10,
    justifyContent: "flex-start",
    marginBottom: 12,
  },
});
